import type { Palette } from '@mui/material/styles';

type Path2<T, K extends string> = T extends object
  ? {
      [SK in keyof T & string]: T[SK] extends string
        ? `${K}.${SK}`
        : T[SK] extends object
          ? {
              [SSK in keyof T[SK] & string]: T[SK][SSK] extends string ? `${K}.${SK}.${SSK}` : never;
            }[keyof T[SK] & string]
          : never;
    }[keyof T & string]
  : never;

/** Dot-notation paths to palette string values, e.g. `primary.main`, `grey.50`. */
export type ThemePaletteColor = {
  [K in keyof Palette & string]: Palette[K] extends string ? K : Path2<Palette[K], K>;
}[keyof Palette & string];

export function resolvePaletteColor(palette: Palette, path: ThemePaletteColor): string {
  const segments = path.split('.');
  let value: unknown = palette;

  for (const segment of segments) {
    if (value == null || typeof value !== 'object') {
      return 'currentColor';
    }
    value = (value as Record<string, unknown>)[segment];
  }

  return typeof value === 'string' ? value : 'currentColor';
}
